import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
import Utils from '../js/utils';
import Employee from '../js/employee';
export default (function (props, _ref) {
  var $ = _ref.$,
      $update = _ref.$update,
      $f7 = _ref.$f7,
      $tick = _ref.$tick,
      $el = _ref.$el;
  var template, emp;
  var evt1 = 'onTemplateSelected';
  $f7.off(evt1).on(evt1, function (data) {
    template = data;
    $update();
  });
  var evt2 = 'onEmployeeSelected';
  $f7.off(evt2).on(evt2, function (data) {
    emp = data;
    $update();
  });

  var save = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(template === undefined || emp === undefined)) {
                _context.next = 3;
                break;
              }

              $f7.dialog.alert('Cần chọn đủ thông tin');
              return _context.abrupt("return");

            case 3:
              _context.next = 5;
              return Base.call({
                table: 'kho_thoc',
                method: '_post',
                params: {
                  id_emp: parseInt(emp.id),
                  id_mau: template.id,
                  so_thoc: parseInt($el.value.find('input[name="so_thoc"]').val()),
                  note: $el.value.find('input[name="note"]').val() || null
                }
              });

            case 5:
              rs = _context.sent;
              $f7.dialog.alert('Đã đóng góp thành công', function () {
                $f7.emit('khothoc-onFormSubmited');
                $el.value.find('.popup-close').click();
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function save() {
      return _ref2.apply(this, arguments);
    };
  }();

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup popup-khothoc-form">
    <div class="view">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">Góp thóc</div>
          <div class="right">
            <a href="#" class="link popup-close" data-popup=".popup-khothoc-form"><i class="icon f7-icons">multiply</i></a>
          </div>
        </div>
      </div>
      <div class="page">
        <div class="page-content">

          <div class="list no-margin">
            <ul>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Nhân viên <a href="/employee-list-popup/${evt2}/">CHỌN</a></div>
                  <div class="item-input-wrap">
                    ${emp && emp.name}
                  </div>
                </div>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Lý do đóng góp <a href="/kho-thoc-template/${evt1}/">CHỌN</a></div>
                  <div class="item-input-wrap">
                    <input type="hidden" name="id_mau" />
                    <div>${template && template.mo_ta}</div>
                  </div>
                </div>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Số thóc đóng góp</div>
                  <div class="item-input-wrap">
                    <input type="number" readonly name="so_thoc" placeholder="Chọn mẫu đóng góp để điền số thóc" value="${template && template.so_thoc}" />
                  </div>
                </div>
              </li>
              <li class="item-content">
                <div class="item-inner">
                    <a class="button button-fill" @click="${save}">Góp thóc</a>
                </div>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>
`
    }
    ;
});